export { createStore, combineReducers, applyMiddleware, compose, isPlainObject, isAction } from 'redux';